import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "./components/Auth/AuthService";

const Home = () => {
    const [loading, setLoading] = useState(true); // Add loading state
      const navigate = useNavigate();
    
      useEffect(() => {
        // Check if the user is already logged in
        const isAuthenticated = AuthService.isAuthenticated();
        if (isAuthenticated) {
          navigate("/dashboard"); // Redirect to dashboard if authenticated
        } else {
          setLoading(false); // Stop loading if not authenticated
        }
      }, [navigate]);

  return (
    <div>
      {/* Embedding Home.html inside an iframe */}
      <iframe
        src="/Home.html"
        width="100%"
        height="100%"
        title="Home"
        style={{ border: "none", height: "99vh", width: "100%"}}
      />
    </div>
  );
};

export default Home;
